import * as React from "react";
import { Box, Typography, TypographyProps } from "@mui/material";

interface Props {
    heading: string;
    children?: React.ReactNode;
}
const mb = { mb: 2 };
export const PageHeading = (p: Props) => {
    return p.children == null ? (
        <Heading sx={mb}>{p.heading}</Heading>
    ) : (
        <Box
            sx={{
                ...mb,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
            }}
        >
            <Heading>{p.heading}</Heading>
            {p.children}
        </Box>
    );
};

interface HeadingProps extends Pick<TypographyProps, "sx"> {
    children: string;
}

const Heading = (p: HeadingProps) => (
    <Typography variant={"h4"} component={"h1"} sx={p.sx}>
        {p.children}
    </Typography>
);
